import Component from './Component'

export default class SortList extends Component {

	static _type = 'SortList'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el

	tether () {
		super.tether()

		// Own DOM elements
		this.list_el = this.base.querySelector('.sortlist')
		this.feedback_el = this.base.querySelector('.invalid-feedback')

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil

		// Create bound event handlers and register them
		this.inputListener = SortList._inputListener.bind(this)
		this.updateListener = SortList._updateListener.bind(this)
		$(this.list_el).on('sortupdate', this.inputListener)							// jQuery event
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)	// node event

		// Initialize sortable
		$(this.list_el).sortable({
			placeholder: "sortlist-item-placeholder",
			containment: this.base,
			//revert: true,
			axis: "y"
		})
		$(this.list_el).disableSelection()
	}

	static _inputListener (event) {

		// Compile data
		let value = $(this.list_el).sortable('toArray', { attribute: 'value' })

		// Send data to the record
		this.form.data[this.params.name] = value
	}

	static _updateListener (value, errors) {

		if (Array.isArray(value)) {
			for (let option_id of value) {
				$(this.list_el).find(`.sortlist-item[value="${option_id}"]`).appendTo(this.list_el)
			}
			$(this.list_el).sortable('refresh')
		}

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	renderValidation (errors) {
		if (errors == null) {
			// Validation successful
			//$(this.input_els).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			//$(this.input_els).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		$(this.list_el).off('sortupdate', this.inputListener)
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)

		// Clear sortable script
		$(this.list_el).sortable('destroy')

		delete this.list_el
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
